import { FC } from 'react'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'
import styles from 'components/features/pfm/LinkedAccounts/LinkedAccountName.styl'

type LinkedAccountNameProps = {
  account: NonNullable<MixedAccountsTableItem['account']>
}
export const LinkedAccountName: FC<LinkedAccountNameProps> = (props) => {
  const { account } = props
  const { name, is_manual } = account

  const endingIn = 'number' in account
    ? account.number
    : null

  return (
    <>
      { name && (
        <div className={ styles.accountName }>
          { name }
        </div>
      )}
      { !is_manual && endingIn && (
        <div className={ styles.note }>
          Ending in: { endingIn }
        </div>
      )}
    </>
  )
}
